import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', label: 'EN', flag: '🇬🇧' },
    { code: 'de', label: 'DE', flag: '🇩🇪' },
    { code: 'el', label: 'ΕΛ', flag: '🇬🇷' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="fixed top-4 right-4 z-50">
      {/* Current language button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-white rounded-full shadow-lg p-3 flex items-center justify-center transition-all duration-200 hover:shadow-xl"
      >
        <span className="text-lg">{currentLanguage.flag}</span>
      </button>

      {/* Slide-in language options */}
      <div className={`absolute top-0 right-0 bg-white rounded-full shadow-lg transition-all duration-300 ease-in-out ${
        isOpen ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0 pointer-events-none'
      }`}>
        <div className="flex items-center p-2 space-x-2">
          <Globe className="w-4 h-4 text-gray-600 ml-2" />
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-200 ${
                i18n.language === lang.code
                  ? 'bg-gray-900 text-white shadow-md'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <span className="sm:hidden">{lang.flag}</span>
              <span className="hidden sm:inline">{lang.flag} {lang.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitcher;